import mapValues from 'lodash-es/mapValues';
import { ObjectIterator } from 'lodash';

export namespace LodashUtils {
  // export function mapObjectValues<TIn, TOut, In extends { [key: string]: TIn }, Out extends { [K in keyof In]: TOut }>(
  //   collection: In,
  //   mapper: (value: In[keyof In], key: string, collection: In) => Out[keyof Out]
  // ): Out {
  //   return mapValues(collection, mapper) as any;
  // }

  export function mapObjectValues<T extends object, TResult>(
    obj: T | null | undefined,
    callback: ObjectIterator<T, TResult>
  ): { [P in keyof T]: TResult } {
    return mapValues(obj, callback);
  }
}



// WEBPACK FOOTER //
// ./src/module/Common/utils/LodashUtils.ts